'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import numeral from 'numeral';
// import moment from 'moment';
// import { Link } from 'react-router';
// import { getColorRatingCode, getAvatar, renderTime, getUrlImage } from 'helpers/lib';
var labelDay = {
  0: 'CN',
  1: 'Th2',
  2: 'Th3',
  3: 'Th4',
  4: 'Th5',
  5: 'Th6',
  6: 'Th7'
};
var Day = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Day, _Component);

  function Day() {
    (0, _classCallCheck3.default)(this, Day);
    return (0, _possibleConstructorReturn3.default)(this, (Day.__proto__ || (0, _getPrototypeOf2.default)(Day)).apply(this, arguments));
  }

  (0, _createClass3.default)(Day, [{
    key: 'isEqual',
    value: function isEqual(date1, date2) {
      if (!date1 || !date2) return false;
      var one = new Date(date1);
      var two = new Date(date2);
      return one.getDate() === two.getDate() && one.getMonth() === two.getMonth() && one.getFullYear() === two.getFullYear();
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Day.scss');
      var _props = this.props,
          _props$data = _props.data,
          date = _props$data.date,
          empty = _props$data.empty,
          selected = _props$data.selected,
          onClick = _props.onClick;

      var _d = new Date(date);
      var label = labelDay[_d.getDay()];
      var value = _d.getDate();
      return _react2.default.createElement(
        'div',
        {
          className: styles.day + ' ' + (date === selected && empty > 0 && styles.active) + ' ' + (empty === 0 && styles.disable),
          onClick: onClick
        },
        _react2.default.createElement(
          'div',
          { className: styles.label },
          label
        ),
        _react2.default.createElement(
          'div',
          { className: styles.value },
          value
        ),
        _react2.default.createElement('div', { className: styles.point + ' ' + (empty > 0 && styles.active) })
      );
    }
  }]);
  return Day;
}(_react.Component), _class.propTypes = {
  onClick: _react.PropTypes.func,
  data: _react.PropTypes.object
}, _temp);
exports.default = Day;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/Day.js
// module id = 1556
// module chunks = 0